export const REGIONS = [
  'MI',
  'PA',
  'NJ',
  'WV',
  'CT',
  'MR',
  'ON',
  'AB',
] as const;

export type RegionCode = (typeof REGIONS)[number];

const LOWERCASE_REGIONS: ReadonlySet<string> = new Set(
  REGIONS.map((region) => region.toLowerCase()),
);

/**
 * Narrows an untrusted string to a known jurisdiction, comparing
 * case-insensitively and returning the lowercase form used at runtime.
 */
export const isValidRegion = (
  value: string | null | undefined,
): value is Lowercase<RegionCode> =>
  typeof value === 'string' && LOWERCASE_REGIONS.has(value.toLowerCase());

/**
 * Returns the normalised lowercase region when `value` is a known
 * jurisdiction, otherwise `undefined`. Callers must treat `undefined` as
 * "reject" rather than falling back to the raw input.
 */
export const normalizeRegion = (
  value: string | null | undefined,
): Lowercase<RegionCode> | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }

  const normalized = value.toLowerCase();
  return LOWERCASE_REGIONS.has(normalized)
    ? (normalized as Lowercase<RegionCode>)
    : undefined;
};
